import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getAPIReOrderParagraph = (params) => {
	const url = ApiRouters.API_REORDER_PARAGRAPH;
	return api.get(url, { params });
};

export const postAPIReOrderParagraph = (body) => {
	const url = ApiRouters.API_REORDER_PARAGRAPH;
	return api.post(url, body);
};

export const getAPIReOrderParagraphDetail = (id) => {
	const url = `${ApiRouters.API_REORDER_PARAGRAPH}/${id}`;
	return api.get(url);
};

export const putAPIReOrderParagraphDetail = (id, body) => {
	const url = `${ApiRouters.API_REORDER_PARAGRAPH}/${id}`;
	return api.put(url, body);
}

export const deleteAPIReOrderParagraph = (id) => {
	const url = `${ApiRouters.API_REORDER_PARAGRAPH}/${id}`;
	return api.delete(url);
};

// export const getReadAloudDetail = (id, params) => {
// 	const url = `${ApiRouters.READALOUD}/${id}`;
// 	return api.get(url, { params });
// };

// export const createQuesReadAloud = (body) => {
// 	const url = ApiRouters.READALOUD;
// 	return api.post(url, body);
// };

// export const updateReadAloudDetail = (body) => {
// 	const url = `${ApiRouters.READALOUD}/${body.id}`;
// 	return api.put(url, body);
// };